import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { showChatWidget } from "@faire/help-center-self-serve/chat/chatWidget";
import { useChatAuthorization } from "@faire/help-center-self-serve/chat/hooks/useChatAuthorization";
import { BRAND_TYPE } from "@faire/help-center-utils/consts/BRAND_TYPE";
import { RETAILER_TYPE } from "@faire/help-center-utils/consts/RETAILER_TYPE";
import { browserLevelLanguage } from "@faire/help-center-utils/serialized-data/getLocale";
import { getRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getRetailerOrBrandCountry } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandCountry";
import { getUserToken } from "@faire/help-center-utils/serialized-data/getUser";
import { getSettingHelpCenterChatAvailableLocales } from "@faire/help-center-utils/settings/getSettingHelpCenterChatAvailableLocales";
import { getSettingHelpCenterLanguageFieldEnabled } from "@faire/help-center-utils/settings/getSettingHelpCenterLanguageFieldEnabled";
import { trackHelpCenterChatProvidedView } from "@faire/web-api/events/helpCenter/view/chatProvided";
import { IFaireMetadata } from "@faire/web-api/sunco/IFaireMetadata";
import { DEFAULT_LOCALE_KEY } from "@faire/web/common/consts/DEFAULT_LOCALE";
import { useStrictLocalization } from "@faire/web/common/localization";
import { useState } from "@faire/web/ui/hooks/useState";
import { useCallback, useEffect } from "react";
import { getAllZenDeskTags } from "../utils/zenDeskTags";
import { useAIChatbotAccess } from "./useAIChatbotAccess";
import { useIssueType } from "./useIssueType";
import { useOrderToken } from "./useOrderToken";
export var useChat = function useChat() {
  var _useIssueType = useIssueType(),
    issueType = _useIssueType.issueType;
  var _useState = useState(issueType.includes("FaireDirectWidgetChat")),
    _useState2 = _slicedToArray(_useState, 2),
    showChat = _useState2[0],
    setShowChat = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loadingChat = _useState4[0],
    setLoadingChat = _useState4[1];
  var _useOrderToken = useOrderToken(),
    orderToken = _useOrderToken.orderToken;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var hasAIChatbotAccess = useAIChatbotAccess();
  var _useChatAuthorization = useChatAuthorization(),
    jwtResponse = _useChatAuthorization.data,
    isLoading = _useChatAuthorization.isLoading,
    chatBtnEnabled = _useChatAuthorization.chatBtnEnabled,
    hasChatAccess = _useChatAuthorization.hasChatAccess;
  /**
   * This is the place where we show the chat widget.
   */
  useEffect(function () {
    setLoadingChat(true);
    if (isLoading) {
      return;
    }
    if (hasAIChatbotAccess) {
      setLoadingChat(false);
      return;
    }
    if (showChat && jwtResponse) {
      var metaData = getFaireMetadata(jwtResponse.metadata, orderToken, issueType);
      showChatWidget(jwtResponse, strictLocalize, metaData).then(function () {
        return setLoadingChat(false);
      });
    }
    setLoadingChat(false);
  }, [showChat, jwtResponse, isLoading, orderToken, issueType, hasAIChatbotAccess, strictLocalize]);
  var trackChatView = useCallback(function () {
    var _getUserToken;
    var userToken = (_getUserToken = getUserToken()) !== null && _getUserToken !== void 0 ? _getUserToken : "";
    trackHelpCenterChatProvidedView(userToken, userToken, issueType);
  }, [issueType]);
  useEffect(function () {
    if (hasChatAccess && chatBtnEnabled) {
      trackChatView();
    }
  }, [chatBtnEnabled, hasChatAccess, trackChatView]);
  return {
    setShowChat: setShowChat,
    loadingChat: loadingChat,
    setLoadingChat: setLoadingChat,
    hasChatAccess: hasChatAccess,
    chatBtnEnabled: chatBtnEnabled
  };
};
var getFaireMetadata = function getFaireMetadata(metaData, orderToken, issueType) {
  var _getRetailerOrBrandCo;
  var retailer = getRetailer();
  var customerType = retailer !== null && retailer !== void 0 && retailer.token ? RETAILER_TYPE : BRAND_TYPE;
  var countryIso = (_getRetailerOrBrandCo = getRetailerOrBrandCountry()) !== null && _getRetailerOrBrandCo !== void 0 ? _getRetailerOrBrandCo : "";
  var tags = getAllZenDeskTags(countryIso, customerType, issueType);
  var chatAvailableLanguages = getSettingHelpCenterChatAvailableLocales().map(function (locale) {
    return locale.language;
  });
  var language = chatAvailableLanguages.includes(browserLevelLanguage()) ? browserLevelLanguage() : DEFAULT_LOCALE_KEY.language;
  if (getSettingHelpCenterLanguageFieldEnabled()) {
    return IFaireMetadata.build(_objectSpread(_objectSpread({}, metaData), {}, {
      tags: tags,
      brand_order_token: orderToken,
      issue_type: issueType,
      language: language
    }));
  } else {
    return IFaireMetadata.build(_objectSpread(_objectSpread({}, metaData), {}, {
      tags: tags,
      brand_order_token: orderToken,
      issue_type: issueType
    }));
  }
};